var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignupSecurityBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#signup-security-badge_svg__clip0_3949_67010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.34 17.221a.522.522 0 01-.398-.183l-2.768-3.241a.524.524 0 11.797-.68l2.435 2.85 6.049-4.92a.524.524 0 11.66.813l-6.444 5.244a.522.522 0 01-.33.117z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.168 27.337l1.42.62a.523.523 0 00.417 0l1.6-.691a15.137 15.137 0 009.276-13.955v-7.18a.524.524 0 00-.278-.462L14.08.062a.523.523 0 00-.498.003L3.348 5.672a.524.524 0 00-.272.46v7.325a15.167 15.167 0 009.09 13.88zM4.125 6.442l9.712-5.323 9.996 5.327v6.865a14.091 14.091 0 01-8.638 12.99l-.004.003-1.393.601-1.211-.528a14.117 14.117 0 01-8.462-12.92V6.442z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.44 23.308l-.004.001-1.393.602-1.211-.528a14.117 14.117 0 01-8.463-12.92V5.21L4.124 6.442v7.015a14.117 14.117 0 008.462 12.92l1.21.528 1.395-.602.003-.001a14.14 14.14 0 006.848-6.12 14.186 14.186 0 01-4.602 3.126z",
    fill: "#ADC6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "signup-security-badge_svg__clip0_3949_67010"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/signup-security-badge.e319e8618cdf2dd6d4360594885a3a45.svg";
export { SvgSignupSecurityBadge as ReactComponent };